import React from 'react';
import { FlatList } from 'react-native';
import { Column } from '../../../containers';
import { AutocompleteResultsRow } from '../../../rows';
import { type ApiResponseRow } from './types';

type AutocompleteResultsProps = {
  readonly items: ApiResponseRow<any>[] | null | undefined;
  readonly handleRowPress: (arg0: ApiResponseRow<any>) => () => void;
  readonly currentText: string;
  /**
   * Optional prefix for each result row's testID (e.g. "e2e-pharmacy-result" yields "e2e-pharmacy-result-0", "-1", …).
   * Enables e2e tests to tap the first result via id: prefix-0.
   */
  readonly testIDPrefix?: string;
};

export const AutocompleteResults = ({ items, handleRowPress, currentText, testIDPrefix }: AutocompleteResultsProps) => {
  return (
    <Column>
      <FlatList
        keyboardShouldPersistTaps="always"
        data={items || []}
        renderItem={({ item, index }: { readonly item: ApiResponseRow<string>; readonly index: number }) => (
          <AutocompleteResultsRow
            {...item}
            onPress={handleRowPress(item)}
            textToHighlight={currentText}
            testID={testIDPrefix ? `${testIDPrefix}-${index}` : undefined}
          />
        )}
        keyExtractor={(row) => row.key}
      />
    </Column>
  );
};
